
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router, RouterLink } from '@angular/router';
import { VerifyAccountService } from './service/verify-account.service';
import { NotificationsService } from '../../shared/components/notifications/service/notifications.service';
import { trigger, transition, style, animate } from '@angular/animations';
import { HomeButtonComponent } from '../../shared/components/home-button/home-button.component';

@Component({
  selector: 'features-verify-account',
  standalone: true,
  imports: [RouterLink, HomeButtonComponent],
  templateUrl: './verify-account.component.html',
  styleUrl: './verify-account.component.css',
  animations: [
    trigger('fadeIn', [
      transition(':enter', [
        style({ opacity: 0 }),
        animate('500ms ease-in', style({ opacity: 1 }))
      ])
    ]),
    trigger('formFields', [
      transition(':enter', [
        style({ opacity: 0, transform: 'translateY(20px)' }),
        animate('500ms 200ms ease-out', style({ opacity: 1, transform: 'translateY(0)' }))
      ])
    ])
  ]
})
export class VerifyAccountComponent implements OnInit {
  private userToken: string | undefined;
  isVerifying: boolean = false;
  isVerified: boolean = false;

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private verifyAccountService: VerifyAccountService,
    private notificationsService: NotificationsService
  ) {}

  ngOnInit() {
    this.route.queryParams.subscribe(params => {
      this.userToken = params['user'];
      if (!this.userToken || this.userToken.length==0) {
        this.notificationsService.addNotification({
          message: 'ID de usuario inválido. No se puede verificar la cuenta.',
          type: 'error'
        });
        this.router.navigate(['/auth/login']);
      }
    });
  }

  verifyAccount() {
    // Si ya está verificado o en proceso de verificación, no hacer nada
    if (this.isVerified || this.isVerifying) {
      this.notificationsService.addNotification({
        message: 'Tu cuenta ya ha sido verificada',
        type: 'info'
      });
      return;
    }

    // Si no hay userId, mostrar error
    if (!this.userToken) {
      this.notificationsService.addNotification({
        message: 'No se pudo verificar la cuenta. ID de usuario no encontrado.',
        type: 'error'
      });
      return;
    }

    // Iniciar proceso de verificación
    this.isVerifying = true;

    this.verifyAccountService.verifyAccount(this.userToken).subscribe({
      next: (response) => {
        this.isVerifying = false;
        this.isVerified = true;
        this.notificationsService.addNotification({
          message: '¡Cuenta verificada correctamente!',
          type: 'success'
        });
      },
      error: (error) => {
        this.isVerifying = false;
        
      }
    });
  }
}
